<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item>
          <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="querychange = true"
            :unlink-panels="false"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.clerkid" clearable filterable remote reserve-keyword placeholder="请选择采购人"
            @change="querychange = true">
            <el-option v-for="(item, index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.supplierid" clearable filterable remote reserve-keyword placeholder="请选择供应商"
            @change="querychange = true">
            <el-option v-for="(item, index) in supplierlists" :key="index" :label="item.apply_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.status" clearable filterable remote reserve-keyword placeholder="请选择状态"
            @change="querychange = true">
            <el-option v-for="(item, index) in statuslists" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.storage_status" clearable filterable remote reserve-keyword placeholder="入库状态"
            @change="querychange = true">
            <el-option v-for="(item, index) in inventoryStatusList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="订单号 / 商品名称 / 商品编号 / 条形码" v-model="query.key" clearable style="width:100%"
            @change="querychange = true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-search" @click="getOrderlists">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-circle-plus-outline" @click="addOrder"
            v-if="actionauth.cg_order_add == 'true'">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-search" @click="exportmoredata">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-badge :value="warntotals" class="item" v-if="warntotals > 0">
            <el-button type="warning" icon="el-icon-search" @click="checkwarninggoods">预警商品</el-button>
          </el-badge>
          <el-button type="warning" icon="el-icon-search" @click="checkwarninggoods"
            v-if="warntotals == 0">预警商品</el-button>
        </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table ref="orderTable" :data="orderlists" style="width: 100%" v-loading="orderlistsloading"
          tooltip-effect="dark">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.goods">
                <el-table-column prop="name" label="商品名称" min-width="250">
                  <template slot-scope="props">
                    <div style="float:left;width:100%;font-size:13px;">{{ props.row.name }}</div>
                    <div style="float:left;width:100%;font-size:12px;color:#999999">编号：{{ props.row.number }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="数量" min-width="120" align="center"></el-table-column>
                <el-table-column prop="paynum" label="入库数量" min-width="120" align="center"></el-table-column>
                <el-table-column prop="unit" label="单位" min-width="120" align="center"></el-table-column>
                <el-table-column prop="price" label="单价" min-width="120" align="center"></el-table-column>
                <el-table-column prop="discount" label="折扣（100%）" min-width="120" align="center"></el-table-column>
                <el-table-column prop="sell" label="折后单价" min-width="120" align="center"></el-table-column>
                <el-table-column prop="total" label="小计" min-width="120" align="center"></el-table-column>
                <el-table-column prop="paytotal" label="入库小计" min-width="120" align="center"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="采购单号" min-width="250">
            <template slot-scope="props">
              <div style="float:left;width:100%">
                <span style="float:left;width:100%">
                  {{ props.row.documents }}
                  <el-tooltip class="item" effect="dark" content="再来一单（复制当前订单生成新采购单）" placement="top">
                    <a style="margin:0 0 0 10px;cursor:pointer" @click="copyorders(props.row.id)">
                      <img src="@/assets/sellicon/copy.png" style="width:15px;height:15px;margin-top:5px" />
                    </a>
                  </el-tooltip>
                </span>
                <span v-if="props.row.iseditnums > 0"
                  style="float:left;line-height:1rem;font-size:.7rem;color:#fff;background:#E6A23C;padding:.1rem .2rem;border-radius:5px;margin-left:5px">改</span>
              </div>
              <div style="float:left;width:100%;font-size:12px;color:#999999">采购人：{{ props.row.clerkname }}</div>
              <div style="float:left;width:100%;font-size:12px;color:#999999">打印次数：{{ props.row.printnumber }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="suppliername" label="供应商" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">{{ props.row.suppliername === '' ? '-' :
                props.row.suppliername}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="合计" min-width="120" align="center"></el-table-column>
          <el-table-column prop="derate" label="优惠金额" min-width="120" align="center"></el-table-column>
          <el-table-column prop="deal" label="成交金额" min-width="120" align="center"></el-table-column>
          <el-table-column prop="inputtime" label="下单时间" min-width="120" align="center"></el-table-column>
          <el-table-column label="状态" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.status == 0">未审核</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.status == 1">已审核</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.status == 2">已生效</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="入库状态" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.storage_status == 1">未入库</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.storage_status == 2">入库中</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.storage_status == 3">部分入库</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.storage_status == 4">全部入库</div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center" min-width="400" fixed="right">
            <template slot-scope="props">
              <el-button type="warning" size="small" round @click.native="getprintorder(props.row.id)">查看</el-button>
              <el-button type="warning" size="small" round @click.native="geteditorder(props.row.id)"
                v-if="props.row.status == 0 && actionauth.cg_order_edit == 'true'">修改</el-button>
              <!-- <el-button type="warning" size="small" round v-if="props.row.status==2 && props.row.createinput==1 && actionauth.cg_order_create=='true'" @click.native="getinputgoods(props.row.id)" >生成入库单</el-button> -->
              <el-button type="warning" size="small" round v-if="props.row.status == 2"
                @click.native="getstoragelog(props.row.id)">查看入库单</el-button>
              <el-button type="warning" size="small" round v-if="props.row.status == 2"
                @click.native="changepurcharseorder(props.row.id)">修改入库单</el-button>
              <el-button type="warning" size="small" round v-if="props.row.iseditnums > 0"
                @click.native="changepurcharseeditlog(props.row.id)">改单记录</el-button>
              <el-tooltip class="item" effect="dark" :content="props.row.kingdeesubmit == 1 ? '订单数据已同步至金蝶' : '将订单数据同步至金蝶'"
                placement="top" v-if="iskingdee == 1">
                <el-button :type="props.row.kingdeesubmit == 1 ? '' : 'warning'" size="small" round
                  @click="kingdeesellsubmit(props.row)">{{ props.row.kingdeesubmit == 1 ? '已同步' : '同步采购单' }}</el-button>
              </el-tooltip>
              <el-button type="primary" size="small" round @click.native="checkInStoreList(props.row)"
                v-if="(props.row.status == 1 || props.row.status == 2) && props.row.createinput == 1">入库</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="orderPageSizeChange" @current-change="orderPageCurrentChange"
            :current-page="query.p" :page-sizes="[10, 20, 50]" :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="order_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!----------- 订单打印页面 ---------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
        <div style="width:100%;text-align:right">每页展示 <input type="text" v-model="rollpage"
            v-on:blur="changepagevlaue(printlists[0].id)"
            style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px" />
          条</div>
        <div id="printContent" v-loading="printLoading">
          <div v-for="(item, index) in printlists" :key="index">
            <span style="float: right">{{ item.pagesize }}</span>

            <div v-if="printsmodel.title == 1" style="font-size: 18px; padding-bottom: 2px; margin-bottom: 0"
              align="center">
              <strong>{{ printsmodel.titlevalue }}</strong>
            </div>

            <ul class="titlelists">
              <li v-if="printsmodel.apply_name == 1">供货商名：{{ item.applyname }}</li>
              <li v-if="printsmodel.documents == 1">单据编号：{{ item.documents }}</li>
              <li v-if="printsmodel.phone == 1">联系电话：{{ item.phone }}</li>
              <li>仓库：{{ item.warehouse_name }}</li>
              <li v-if="printsmodel.clerkname == 1">采购人员：{{ item.clerkname }}</li>
              <li v-if="printsmodel.desc == 1">采购备注：{{ item.desc }}</li>
              <li v-if="printsmodel.address == 1" style="width: 100%">联系地址：{{ item.address }}</li>
            </ul>

            <table border="1" cellspacing="0" cellpadding="1" width="100%"
              style="border-collapse: collapse; font-size: 15px" bordercolor="#333333">
              <tr class="contactcontent">
                <td>
                  <div align="center"><b>序号</b></div>
                </td>
                <td v-if="printsmodel.number == 1">
                  <div align="center"><b>编号</b></div>
                </td>
                <td v-if="printsmodel.name == 1">
                  <div align="center"><b>商品</b></div>
                </td>
                <td>
                  <div align="center"><b>箱装规格</b></div>
                </td>
                <td v-if="printsmodel.spec == 1">
                  <div align="center"><b>规格</b></div>
                </td>
                <td v-if="printsmodel.unit == 1">
                  <div align="center"><b>单位</b></div>
                </td>
                <td v-if="printsmodel.num == 1">
                  <div align="center"><b>数量</b></div>
                </td>
                <td>
                  <div align="center"><b>剩余入库数量</b></div>
                </td>
                <td v-if="printsmodel.sell == 1">
                  <div align="center"><b>单价</b></div>
                </td>
                <td v-if="printsmodel.discount == 1">
                  <div align="center"><b>折扣</b></div>
                </td>
                <td v-if="printsmodel.dis_sell == 1">
                  <div align="center"><b>折后单价</b></div>
                </td>
                <td v-if="printsmodel.total == 1">
                  <div align="center"><b>小计</b></div>
                </td>
                <!-- 新增货位列 -->
                <td v-if="printsmodel.storage_location == 1">
                  <div align="center"><b>货位</b></div>
                </td>
              </tr>

              <tr v-for="(tt, ii) in item.goods" :key="ii" class="contactcontent">
                <td align="center">{{ tt.gsort }}</td>
                <td v-if="printsmodel.number == 1" align="center">{{ tt.number }}</td>
                <td v-if="printsmodel.name == 1" style="padding-left: 1%">{{ tt.name }}</td>
                <td style="padding-left: 1%">{{ tt.box_gauge }}</td>
                <td v-if="printsmodel.spec == 1" style="padding-left: 1%">{{ tt.spec }}</td>
                <td v-if="printsmodel.unit == 1" align="center">{{ tt.unit }}</td>
                <td v-if="printsmodel.num == 1" align="center">{{ tt.num }}</td>
                <td align="center">{{ tt.remaining_inventory }}</td>
                <td v-if="printsmodel.sell == 1" align="center">{{ tt.price }}</td>
                <td v-if="printsmodel.discount == 1" align="center">{{ tt.discount }}</td>
                <td v-if="printsmodel.dis_sell == 1" align="center">{{ tt.sell }}</td>
                <td v-if="printsmodel.total == 1" align="center">{{ tt.total }}</td>
                <!-- 货位信息展示 -->
                <td v-if="printsmodel.storage_location == 1" align="center" style="padding: 5px 0">
                  <div v-for="(loc, li) in tt.storage_location" :key="li">
                    {{ loc.full_code }}
                    <span style="color: red">[{{ loc.numbers }}]</span>
                  </div>
                </td>
              </tr>

              <tr v-if="index + 1 == printlists.length" class="contactcontent">
                <td align="center">合计</td>
                <td v-if="printsmodel.number == 1" style="padding-left: 1%"></td>
                <td v-if="printsmodel.name == 1" style="padding-left: 1%"></td>
                <td style="padding-left: 1%"></td>
                <td v-if="printsmodel.spec == 1" style="padding-left: 1%"></td>
                <td v-if="printsmodel.unit == 1" align="center"></td>
                <td v-if="printsmodel.num == 1" align="center">{{ item.goodscount }}</td>
                <td align="center">{{ getAllRemainingInventory(item.goods) }}</td>
                <td v-if="printsmodel.sell == 1" align="center"></td>
                <td v-if="printsmodel.discount == 1" align="center"></td>
                <td v-if="printsmodel.dis_sell == 1" align="center"></td>
                <td v-if="printsmodel.total == 1" align="center">{{ item.total }}</td>
                <!-- 合计行的货位列留空 -->
                <td v-if="printsmodel.storage_location == 1"></td>
              </tr>
            </table>

            <table border="0" cellspacing="0" cellpadding="0" width="100%">
              <tbody>
                <tr class="top1">
                  <td v-if="printsmodel.inputtime == 1"><span>录单日期：{{ item.inputtime }}</span></td>
                  <td v-if="printsmodel.verifyer == 1"><span>审核人：{{ item.verifyername }}</span></td>
                  <td v-if="printsmodel.manager == 1"><span>操作人：{{ item.managername }}</span></td>
                </tr>
                <tr class="top1">
                  <td v-if="printsmodel.alltotal == 1"><span>合计金额：{{ item.total }} 元</span></td>
                  <td v-if="printsmodel.derate == 1"><span>优惠金额：{{ item.derate }} 元</span></td>
                  <td v-if="printsmodel.deals == 1"><span>实付金额：{{ item.deals }} 元</span></td>
                </tr>
              </tbody>
            </table>
            <div class="pageBreak"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="printerDialog = false">取 消</el-button>
          <el-button size="small" type="primary" icon="el-icon-printer" @click="createnoSave"
            :loading="printorderLoading">打印订单</el-button>
          <el-button size="small" type="danger" icon="el-icon-back" @click="cannelverify" :loading="cannelLoading"
            v-if="orderstatus == 1 && actionauth.cg_order_cannel == 'true'">撤销审核</el-button>
          <!-- <el-button size="small" type="primary" @click="finishorder" :loading="finishLoading"
            v-if="orderstatus == 1 && actionauth.cg_order_sure == 'true'">入库</el-button> -->
          <el-button size="small" type="primary" icon="el-icon-search" @click="exportorder"
            :loading="exportorderLoading" v-if="orderstatus == 1 || orderstatus == 2">导出</el-button>
        </div>
      </el-dialog>
      <!----------- 订单打印页面 ---------------->




      <!--------------新增采购单---------------->
      <el-dialog title="新增/编辑销售采购单" :visible.sync="addDialog" width="95%" top="3vh">
        <el-form :inline="true" class="demo-form-inline" ref="search" size="medium">
          <el-form-item>
            <el-select v-model="create.supplierid" clearable filterable remote reserve-keyword placeholder="请选择供应商"
              @change="changesupplier">
              <el-option v-for="(item, index) in supplierlists" :key="index" :label="item.apply_name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入条形码" v-model="codekey" style="width:100%"
              @keyup.enter.native="searchgoodsfromcode">
              <template slot="prepend">查找</template>
              <el-button slot="append" icon="el-icon-search" @click="searchgoodsfrombutton"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="addproducts">添加采购商品</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="clearselectgoods">清空采购商品</el-button>
            <el-tooltip class="item" effect="dark" content="可对下面的商品列表进行拖拽排序" placement="top">
              <el-button :type="sorttype" :icon="sorticon" @click="startandstopsort">{{ sortname }}</el-button>
            </el-tooltip>
          </el-form-item>
        </el-form>
        <el-table :data="create.goods" border show-summary :summary-method="totalRule" style="width: 100%"
          v-loading="goodsListLoading" v-if="sorttable == true">
          <el-table-column label="序号" prop="serial" width="90" align="center"></el-table-column>
          <el-table-column label="编号" prop="number" width="90" align="center"></el-table-column>
          <el-table-column label="商品名称" prop="name"></el-table-column>
          <el-table-column label="规格" prop="spec" width="85" align="center"></el-table-column>
          <el-table-column label="单位" prop="unit" width="85" align="center">
            <template slot-scope="props">
              <el-input size="medium" v-model="create.goods[props.$index].unit"
                @focus="getUnitlists(props.row.productid, props.row.id, props.row.unitid)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单价" width="145" align="center">
            <template slot-scope="props">
              <el-input size="medium" v-model="create.goods[props.$index].sell"
                @blur="setgoodssell(props.row.id, props.row.sell)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="120" align="center">
            <template slot-scope="props">
              <el-input size="medium" v-model="create.goods[props.$index].num"
                @blur="setgoodsnum(props.row.id, props.row.num)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="小计" width="145" align="center">
            <template slot-scope="props">
              <el-input size="medium" v-model="create.goods[props.$index].total"
                @blur="setgoodstotal(props.row.id, props.row.total)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="props">
              <el-button type="warning" size="small" icon="el-icon-document" circle
                @click="copygoods(props.row.id)"></el-button>
              <el-button type="danger" size="small" icon="el-icon-delete" circle
                @click="delgoods(props.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!---拖拽商品信息----->
        <draggable :list="listsorts" :move="getdata" @update="datadragEnd" :options="{ animation: 200, handle: '.dargDiv' }"
          v-if="sorttable == false">
          <transition-group name="list-complete">
            <div class="dargDiv" v-for="(item, index) in listsorts" :key="index"
              style="float:left;width:100%;border-bottom:1px dashed #dddddd;">
              <span style="float:left;width:7%;padding:15px 0 15px 1%">{{ item.number }}</span>
              <span style="float:left;width:38%;padding:15px 0 15px 2%">{{ item.name }}</span>
              <span style="float:left;width:7%;padding:15px 0 15px 2%">{{ item.spec }}</span>
              <span style="float:left;width:7%;padding:15px 0 15px 2%">{{ item.unit }}</span>
              <span style="float:left;width:7%;padding:15px 0 15px 2%">{{ item.sell }}</span>
              <span style="float:left;width:7%;padding:15px 0 15px 2%">{{ item.num }}</span>
              <span style="float:left;width:7%;padding:15px 0 15px 2%">{{ item.total }}</span>
            </div>
          </transition-group>
        </draggable>
        <!---拖拽商品信息----->

        <el-col :span="24">&nbsp;</el-col>
        <el-col :span="24">&nbsp;</el-col>
        <div
          style="border:1px solid #ebeef5;border-radius:6px;padding:20px;padding-bottom:0px;margin-bottom:20px;width:96.3%;float:left;background:#dddddd">
          <el-form ref="create" :model="create" style="width:100%" size="medium">
            <el-col :span="24">
              <el-col :span="6">
                <el-form-item label="单据编号">
                  <el-col :span="15">
                    <el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合计金额">
                  <el-col :span="14">
                    <el-input placeholder="合计金额" v-model="create.total" :disabled="true"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="优惠金额">
                  <el-col :span="14">
                    <el-input placeholder="优惠金额" v-model="create.derate" @blur="setderate"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="实付金额">
                  <el-col :span="14">
                    <el-input placeholder="应付金额" v-model="create.deals" @blur="setdeal"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="采购人员">
                  <el-col :span="15">
                    <el-select v-model="create.clerkid" clearable filterable remote reserve-keyword
                      placeholder="请选择采购人员" @change="setseller">
                      <el-option v-for="(item, index) in sellerLists" :key="index" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单备注">
                  <el-col :span="14">
                    <el-input placeholder="请填写订单备注" v-model="create.desc" @blur="setdesc"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-col>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="addDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="saveorder" :loading="saveorderLoading">保存订单</el-button>
          <el-button size="medium" type="danger" @click="delorder" :loading="delorderLoading"
            v-if="create.id > 0 && create.status == 0 && actionauth.cg_order_del == 'true'">删除订单</el-button>
          <el-button size="medium" type="warning" @click="verifyorder" :loading="verifyorderLoading"
            v-if="create.isdraft == 1 && actionauth.cg_order_verify == 'true'">审核订单</el-button>
          <el-button size="medium" type="warning" @click="verifyandprintorder" :loading="verifyandprintLoading"
            v-if="create.isdraft == 1 && actionauth.cg_order_verify == 'true'">审核并打印订单</el-button>
        </div>
      </el-dialog>

      <!--------- 采购商品信息列表 ------------>
      <el-dialog title="添加采购商品信息" :visible.sync="addgoodsDialog" width="75%" top="3vh">
        <el-form :inline="true" class="demo-form-inline" size="medium">
          <el-form-item style="width:15%">
            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="changebrand">
              <el-option v-for="(item, index) in brandlists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:15%">
            <el-cascader :options="categorylist" v-model="productquery.catid" clearable
              @change="changecate"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="商品名称 / 编号 / 拼音码 / 条形码" v-model="productquery.key" clearable
              @keyup.enter.native="getProductList" @change="selectproduct = true" @input="changesearchkey"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading"
          tooltip-effect="dark" @row-click="rowclick" @select="handleSelectsingle" @select-all="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="number" label="编号" width="120"></el-table-column>
          <el-table-column prop="brandname" label="品牌" width="120"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="spec" label="规格" width="90" align="center"></el-table-column>
          <el-table-column prop="showsell" label="批发价" width="120" align="center"></el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="productPageSizeChange" @current-change="productPageCurrentChange"
            :current-page="productquery.p" :page-sizes="[10, 20, 50]" :page-size="productquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="product_order_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="addgoodsDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="addgoods">保存订单</el-button>
        </div>
      </el-dialog>

      <!-------------获取单位信息列表--------------->
      <el-dialog title="单位信息" :visible.sync="unitDialog" width="35%" top="5vh">
        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column prop="buy" label="采购价" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="props">
              <el-button type="success" icon="el-icon-check" size="small" circle
                @click="saveunitid(props.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!---------------- 获取生成进货入库商品信息 -------------->
      <el-dialog title="生成进货入库单信息" :visible.sync="inputDialog" width="87%" top="5vh">
        <el-tag type="danger">温馨提示：没有入库的商品请将入库数量设置为 0</el-tag>
        <el-button type="warning" size="small" @click="addgift" style="float:right">添加赠送商品</el-button>
        <el-table :data="inputlists" style="width:100%;margin-top:15px" v-loading="inputLoading">
          <el-table-column prop="name" label="商品" min-width="250">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">
                {{ props.row.name }}
                <span v-if="props.row.isgift == 1">（赠品）</span>
              </div>
              <div style="float:left;width:100%;font-size:12px;color:#999999">编号：{{ props.row.number }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="数量" align="center" min-width="100">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 0">{{ props.row.num }}
                {{ props.row.unit }}</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 1">0</div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" align="center" min-width="100">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 0">{{ props.row.price }}</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 1">0</div>
            </template>
          </el-table-column>
          <el-table-column prop="discount" label="折扣（100%）" align="center" min-width="100">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 0">{{ props.row.discount }}</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 1">0</div>
            </template>
          </el-table-column>
          <el-table-column prop="sell" label="折后单价" align="center" min-width="100">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 0">{{ props.row.sell }}</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 1">0</div>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="小计" align="center" min-width="100">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 0">{{ props.row.total }}</div>
              <div style="float:left;width:100%;font-size:13px;" v-if="props.row.isgift == 1">0</div>
            </template>
          </el-table-column>
          <el-table-column label="入库数量" align="center" min-width="140">
            <template slot-scope="props">
              <el-input size="small" type="input" v-model="props.row.paynum" @blur="changenum(props.$index, props.row)">
                <template slot="append">{{ props.row.unit }}</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="paytotal" label="入库小计" align="center" min-width="100">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">{{ props.row.paytotal }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="100" fixed="right">
            <template slot-scope="props">
              <el-button type="" size="small" round @click="delgift(props.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="inputDialog = false">取 消</el-button>
          <el-button size="small" type="warning" @click="savestorage">确定</el-button>
        </div>
      </el-dialog>

      <!---------------- 获取采购单生成的进货入库订单记录 -------------->
      <el-dialog title="采购单商品入库信息记录" :visible.sync="purchasecreateDialog" width="65%" top="5vh">
        <el-table :data="purchasecreatelog" style="width:100%;margin-top:15px" v-loading="purchasecreateLoading">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.goods">
                <el-table-column prop="name" label="商品" min-width="250">
                  <template slot-scope="props">
                    <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.name }}</div>
                    <div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999">
                      编号：{{ props.row.number }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="数量" min-width="120" align="center">
                  <template slot-scope="props">
                    <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.num }}
                      {{ props.row.unit }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="total" label="小计" min-width="120" align="center">
                  <template slot-scope="props">
                    <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.total }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="120" align="center">
                  <template slot-scope="grops">
                    <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.statusname }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="documents" label="进货单号"></el-table-column>
          <el-table-column prop="total" label="总金额" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.total }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="inputtime" label="生成日期" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.inputtime }}</div>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;line-height:23px;">{{ props.row.statusname }}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!------------- 导出采购单商品信息 --------------->
      <el-dialog title="导出信息确认" :visible.sync="exportorderDialog" width="98%" top="5vh">
        <el-button size="small" type="danger" @click="sureoutput"
          style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
        <div id="outputorder">
          <el-table :data="exportdata" v-loading="exportorderLoading">
            <el-table-column prop="gsort" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="documents" label="单据编号" width="90"></el-table-column>
            <el-table-column prop="number" label="编号" width="90" align="center"></el-table-column>
            <el-table-column prop="name" label="商品"></el-table-column>
            <el-table-column prop="box_gauge" label="箱装规格" width="110" align="center"></el-table-column>
            <el-table-column prop="spec" label="规格" width="90" align="center"></el-table-column>
            <el-table-column prop="unit" label="单位" width="90" align="center"></el-table-column>
            <el-table-column prop="num" label="数量" width="90" align="center"></el-table-column>
            <el-table-column prop="remaining_quantity" label="剩余入库数量" width="90" align="center"></el-table-column>
            <el-table-column prop="price" label="单价" width="90" align="center"></el-table-column>
            <el-table-column prop="discount" label="折扣" width="90" align="center"></el-table-column>
            <el-table-column prop="sell" label="折后单价" width="90" align="center"></el-table-column>
            <el-table-column prop="total" label="小计" width="90" align="center"></el-table-column>
            <el-table-column prop="inputtime" label="下单时间" width="110" align="center"></el-table-column>
            <el-table-column prop="verifytime" label="审核时间" width="110" align="center"></el-table-column>
            <el-table-column prop="suppliername" label="供应商" width="90" align="center"></el-table-column>
            <el-table-column prop="clerkname" label="采购人" width="90" align="center"></el-table-column>
            <el-table-column prop="verifyername" label="审核人" width="90" align="center"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="exportorderDialog = false">取 消</el-button>
          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
        </div>
      </el-dialog>


      <!------选择赠送商品-------------->
      <el-dialog title="选择赠送商品" :visible.sync="giftDialog" width="55%" top="5vh">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item>
            <el-select v-model="giftquery.brandid" clearable filterable placeholder="按品牌" @change="changegiftbrand">
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-cascader :options="categorylist" v-model="giftquery.catid" clearable
              @change="changegiftcate"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="商品名称 / 编号 / 拼音码 / 条形码" v-model="giftquery.key" clearable
              @keyup.enter.native="getgiftgoods" @change="selectgiftproduct = true"
              @input="changegiftsearchkey"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="getgiftgoods">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="giftmultipleTable" :data="giftlists" style="width: 100%" v-loading="giftLoading"
          tooltip-effect="dark" @row-click="giftrowclick" @select="gifthandleSelectsingle"
          @select-all="gifthandleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="商品名称">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">{{ props.row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="编号" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">{{ props.row.number }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="giftproductPageSizeChange" @current-change="giftproductPageCurrentChange"
            :current-page="giftquery.p" :page-sizes="[10, 20, 50]" :page-size="giftquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="product_gift_row">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="giftDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="addgiftgoods">保存</el-button>
        </div>
      </el-dialog>

      <!-- 修改采购单信息 -->
      <el-dialog title="修改采购单信息" :visible.sync="editorderDialog" width="60%" top="5vh">
        <el-table :data="editlistsdata.lists" style="width: 100%" v-loading="editorderLoading">
          <el-table-column prop="name" label="商品名称" min-width="250">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">{{ props.row.name }}</div>
              <div style="float:left;width:100%;font-size:12px;color:#999999">编号：{{ props.row.number }}</div>
            </template>
          </el-table-column>
          <el-table-column label="采购数量" min-width="120" align="center">
            <template slot-scope="scope">
              <el-input size="small" type="input" v-model="scope.row.num">
                <template slot="append">{{ scope.row.unit }}</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="paynum" label="入库数量" min-width="120" align="center">
            <template slot-scope="props">
              <div style="float:left;width:100%;font-size:13px;">{{ props.row.paynum }}</div>
            </template>
          </el-table-column>
        </el-table>
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" placeholder="备注" v-model="editlistsdata.note"
          style="margin-top:20px;"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="editorderDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="saveeditloading" @click="saveeditorder">保存</el-button>
        </div>
      </el-dialog>

      <!-- 查看采购单信息修改记录 -->
      <el-dialog title="采购单信息修改记录" :visible.sync="editlogDialog" width="60%" top="5vh">
        <ul class="editlogs">
          <li v-for="(item, index) in editlogs" :key="index">
            <div class="title">
              <span>修改人：{{ item.truename }}</span>
              <span>修改时间：{{ item.inputtime }}</span>
              <h style="text-align:left">修改备注：{{ item.note }}</h>
            </div>
            <div class="goodslists">
              <div class="goods" v-for="(tt, ii) in item.lists" :key="ii">
                <span class="name">{{ tt.name }}</span>
                <span class="number">{{ tt.number }}</span>
                <span class="spec">{{ tt.spec }}</span>
                <span class="basenum">{{ tt.basenum }}</span>
                <span class="num">{{ tt.num }}</span>
                <span class="unit">({{ tt.unit }})</span>
              </div>
            </div>
          </li>
        </ul>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="editlogDialog = false">取 消</el-button>
        </div>
      </el-dialog>


      <!-- 查看复制的采购单信息 -->
      <!-- <el-dialog title="获取复制的采购单信息" :visible.sync="copyDialog" width="60%" top="10vh"></el-dialog> -->
      <!-- 预警商品模块 -->
      <warngoods v-model="warngoodsview" @close="closewarn" @finish="showwarngoods" />

      <checkInStoreDialog ref="checkInStoreDialogRef" @confirm="handleCheckInStore" />

    </div>
  </transition>
</template>

<script>

/* 导入拖拽组件 */
import draggable from 'vuedraggable'
import warngoods from '@/components/purchase/warn/goods'
import checkInStoreDialog from './checkInStore.vue'

export default {
  components: { draggable, warngoods, checkInStoreDialog },

  data() {
    return {
      url: this.GLOBAL.domain + "Purchase/index",
      transitionshow: true,
      actionauth: [],
      querychange: false,
      orderlistsloading: false,
      orderlists: [],
      order_rows: 0,
      query: {
        act: 'orderlists',
        storage_status: '',
        token: this.$cookies.get('token'),
        date: [],
        clerkid: '',
        supplierid: '',
        status: '',
        key: '',
        p: 1,
        rollpage: 10
      },
      sellerLists: [],
      supplierlists: [],
      statuslists: [{ id: 1, name: '未审核' }, { id: 2, name: '已审核' }, { id: 3, name: '已生效' }],
      inventoryStatusList: [{ id: 1, name: '部分入库' }],
      addDialog: false,
      goodsListLoading: false,
      codekey: '',
      create: {
        act: 'saveorder',
        token: this.$cookies.get('token'),
        id: 0,
        documents: '',
        clerkid: '',
        total: 0.00,
        derate: 0.00,
        deal: '',
        managerid: '',
        supplierid: '',
        desc: '',
        status: 0,
        isdraft: '',
        type: '',
        goods: [],
      },
      changegoodsid: '',
      changeunitid: '',
      unitlists: [],
      addgoodsDialog: false,
      addListLoading: false,
      selectproduct: false,
      productquery: {
        act: 'inventory',
        token: this.$cookies.get('token'),
        brandid: '',
        catid: [],
        supplierid: '',
        key: '',
        p: 1,
        rollpage: 10
      },
      brandlists: [],
      categorylist: [],
      productlists: [],
      product_order_rows: 0,
      selectproductids: [],
      singledisable: false,
      nowtime: 0,
      timeoutflag: true,
      saveorderLoading: false,
      delorderLoading: false,
      verifyorderLoading: false,
      verifyandprintLoading: false,
      unitDialog: false,
      unitListLoading: false,
      sorttable: true,
      sorttype: 'success',
      sorticon: 'el-icon-circle-check-outline',
      sortname: '启用排序',
      listsorts: [],
      printerDialog: false,
      printlists: [],
      printLoading: false,
      rollpage: 10,
      printsmodel: [],
      printorderLoading: false,
      cannelLoading: false,
      orderstatus: '',
      finishLoading: false,
      inputDialog: false,
      inputLoading: false,
      inputlists: [],
      inputid: '',
      purchasecreateDialog: false,
      purchasecreateLoading: false,
      purchasecreatelog: [],
      exportorderLoading: false,
      exportorderDialog: false,
      exportdata: [],
      exportquery: {
        'act': 'getexportdata',
        'token': this.$cookies.get('token'),
        'id': '',
        'date': [],
        'clerkid': [],
        'supplierid': '',
        'status': '',
        isexport: 1,
        'key': '',
      },
      giftDialog: false,
      giftLoading: false,
      giftlists: [],
      giftquery: {
        act: 'getgiftgoods',
        token: this.$cookies.get('token'),
        ids: [],
        applyid: '',
        brandid: '',
        catid: '',
        key: '',
        p: 1,
        rollpage: 10
      },
      product_gift_row: 0,
      selectgiftproduct: false,
      addgiftListLoading: false,
      giftnowtime: 0,
      gifttimeoutflag: true,
      giftselectproductids: [],
      editorderDialog: false,
      editorderLoading: false,
      saveeditloading: false,
      editlistsdata: [],
      editlogDialog: false,
      editlogloading: false,
      editlogs: [],
      iskingdee: 0,
      warngoodsview: false,
      warntotals: 0,
      storageLocationStatus: false,
      batchStatus: false,

    }
  },
  created() {
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
  },

  mounted() {
    this.getactionauth(); //获取权限设置
    this.getSeller(); //获取销售员信息
    this.getSupplier(); //获取供应商信息
    this.getCategoryList(); //获取商品分类
    this.getBrand(); //获取品牌信息类表
    this.getprintsmodel(); //获取采购单打印模板
    this.getOrderlists(); //获取订单信息列表
    this.checkiskingdee(); //查看当前代理商是否开启金蝶权限  
  },

  methods: {

    /** 获取采购预警商品总数量 **/
    getwarntotals() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'getwarntotals', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.warntotals = result.warntotals
        }
      }).catch((res) => {

      });
    },


    /** 查看预警商品信息 **/
    checkwarninggoods() {
      this.warngoodsview = true;
    },
    /** 关闭当前窗口 **/
    closewarn() {
      this.warngoodsview = false;
    },
    /** 查看已添加的预警商品 **/
    showwarngoods() {
      this.warngoodsview = false;
      this.$emit('listenchild', { name: '新增采购单', url: 'Purcharorderadd', data: { isreshpurchaseadd: 2 } });
    },

    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    // 获取剩余库存数量总计
    getAllRemainingInventory(list) {
      return list.reduce((total, item) => {
        return total + (item.remaining_inventory || 0);
      }, 0);

    },

    /** 查看当前代理商是否开启了金蝶权限 **/
    checkiskingdee() {
      var resource = this.$resource(this.GLOBAL.domain + "kingdee/index");
      resource.save({ act: 'isopenkingdee', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.iskingdee = result.iskingdee;
        }
      }).catch((res) => {

      });
    },

    /** 获取打印模板设置 **/
    getprintsmodel() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getmodelsetting', id: 6, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
        }
      }).catch((res) => {
      });
    },

    /** 获取销售员 **/
    getSeller() {
      var resource = this.$resource(this.GLOBAL.domain + "Clerk/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取供应商信息 **/
    getSupplier() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getapplyAll', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.supplierlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取产品分类 **/
    getCategoryList() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取订单信息列表 **/
    getOrderlists() {
      if (this.querychange == true) {
        this.query.p = 1;
        this.query.rollpage = 10;
      }

      this.orderlistsloading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.orderlistsloading = false;
        } else {
          this.orderlists = JSON.parse(Base64.decode(res.data.Data));
          this.order_rows = parseInt(res.data.count);
          if (this.querychange == true) this.querychange = false;
          this.orderlistsloading = false;
          this.getwarntotals(); //获取采购预警商品总数量

          //打印完成刷新页面时重新加载参数
          if (this.$cookies.get('print_back_data_Purcharorder') && this.$cookies.get('print_back_data_Purcharorder') != '') {
            var data = this.$cookies.get('print_back_data_Purcharorder');
            data = JSON.parse(data);
            this.querychange = data.querychange;
            this.query = data.query;
            this.$cookies.set('print_back_data_Purcharorder', '');
            this.getOrderlists();
          }


        }
      }).catch((res) => {
        this.orderlistsloading = false;
      });
    },

    orderPageSizeChange(val) {
      this.query.rollpage = val;
      this.getOrderlists();
    },
    orderPageCurrentChange(val) {
      this.query.p = val;
      this.getOrderlists();
    },


    /** 新增采购单 **/
    addOrder() {
      this.$emit('listenchild', { name: '新增采购单', url: 'Purcharorderadd' });
      //重置采购单信息
      /**
        this.create.id=0;
        this.create.documents='';
        this.create.total=0.00;
        this.create.derate=0.00;
        this.create.deal=0.00;
        this.create.managerid='';
        this.create.supplierid='';
        this.create.desc='';
        this.create.status=0;
        this.create.isdraft='';
        this.create.goods=[];	        	
      this.addDialog=true;
      this.selectproductids=[];
      this.create.clerkid='';
    	
      this.sorttable=true;
      this.sorttype='success';
      this.sorticon='el-icon-circle-check-outline';
      this.sortname='启用排序';	    	
      this.getsingleorder(1);
      */
    },

    /** 获取单个订单信息 **/
    getsingleorder(type) {
      this.goodsListLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getorderinfo', token: this.$cookies.get('token'), type: type }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.goodsListLoading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.create.documents = result.documents;
          this.create.total = result.total;
          this.create.derate = result.derate;
          this.create.deals = result.deals;
          this.create.managerid = result.managerid == 0 ? '' : result.managerid;
          this.create.supplierid = result.supplierid == 0 ? '' : result.supplierid;
          this.create.desc = result.desc;
          this.create.status = result.status;
          this.create.clerkid = result.clerkid;
          this.create.isdraft = result.isdraft;
          this.create.type = result.type;
          if (this.create.clerkid == 0 && this.sellerLists.length == 0) this.create.clerkid = '';
          if (this.create.clerkid == 0 && this.sellerLists.length > 0) this.create.clerkid = this.sellerLists[0].id;
          this.create.goods = result.goods;

          var _this = this;
          this.listsorts = [];
          this.create.goods.forEach(function (e, index) {
            _this.listsorts.push({ id: e.id, number: e.number, name: e.name, spec: e.spec, unit: e.unit, num: e.num, sell: e.sell, total: e.total });
          });
          this.goodsListLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.goodsListLoading = false;
      });
    },

    /** 添加采购商品 **/
    addproducts() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }

      //重置搜索条件
      this.productquery.brandid = '';
      this.productquery.catid = [];
      this.productquery.supplierid = this.create.supplierid;
      this.productquery.key = '';
      this.productquery.p = 1;
      this.productquery.rollpage = 10;

      this.addgoodsDialog = true;
      this.selectproductids = [];
      this.getProductList();
    },

    /** 改变品牌 **/
    changebrand() {
      this.selectproduct == true;
      this.getProductList();
    },

    /** 改变分类 **/
    changecate() {
      this.selectproduct == true;
      this.getProductList();
    },

    /** 关键字搜索 **/
    changesearchkey() {
      //网络异常请求加载数据缓慢时禁止向服务器请求加载数据，缓解服务器压力，等上一次数据加载完后再重亲请求加载数据
      if (this.addListLoading == true) { return false; }
      this.getProductList();
    },

    //条形码搜索商品
    searchgoodsfromcode() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }

      //重置搜索条件
      this.productquery.brandid = '';
      this.productquery.catid = [];
      this.productquery.supplierid = this.create.supplierid;
      this.productquery.key = '';
      this.productquery.p = 1;
      this.productquery.rollpage = 10;
      this.selectproductids = [];

      //检测商品是否只有一个，如果有则直接添加进入购物车，如果有多个则展开列表
      var resource = this.$resource(this.url);
      resource.save({ act: 'checkgoodsnums', token: this.$cookies.get('token'), code: this.codekey, supplierid: this.create.supplierid }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.codekey = '';
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          if (result.count == 0) {
            this.codekey = '';
            this.$message.error("该商品信息不存在");
          } else if (result.count == 1) {
            this.codekey = '';
            this.selectproductids.push(result.productid);
            this.addgoods();
          } else {
            this.productquery.key = this.codekey;
            this.codekey = '';
            this.addgoodsDialog = true;
            this.getProductList();
          }
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    //条形码搜索商品（按钮查询）
    searchgoodsfrombutton() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }

      //重置搜索条件
      this.productquery.brandid = '';
      this.productquery.catid = [];
      this.productquery.supplierid = this.create.supplierid;
      this.productquery.key = this.codekey;
      this.productquery.p = 1;
      this.productquery.rollpage = 10;
      this.selectproductids = [];
      this.codekey = '';

      this.addgoodsDialog = true;
      this.getProductList();
    },

    /** 查询采购商品信息 **/
    getProductList() {
      if (this.selectproduct == true) {
        this.productquery.p = 1;
        this.productquery.rollpage = 10;
      }

      this.productquery.supplierid = this.create.supplierid;
      this.addListLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.productquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        } else {
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.product_order_rows = parseInt(res.data.count);
          this.addListLoading = false;
          if (this.selectproduct == true) this.selectproduct = false;
          this.defaultselectgoods(); //获取已勾选的商品信息
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addListLoading = false;
      });
    },

    totalRule() {
      var _this = this;
      var price = 0;
      var num = 0;
      var total = 0;
      this.create.goods.forEach(function (e, index) {
        price += parseFloat(e.sell);
        num += parseInt(e.num);
        total += parseFloat(e.total);
      });
      price = price.toFixed(2);
      total = total.toFixed(2);
      return ['合计', '', '', '', '', price, num, total];
    },

    productPageSizeChange(val) {
      this.productquery.rollpage = val;
      this.getProductList();
    },
    productPageCurrentChange(val) {
      this.productquery.p = val;
      this.getProductList();
    },


    /** 点击单行选择/取消选中商品  **/
    rowclick(val, row) {
      this.nowtime++;
      if (this.timeoutflag == false) return false;

      var _this = this;
      this.timeoutflag = false;
      setTimeout(function () {
        if (_this.nowtime == 1) { //单击事件
          _this.selectrow(val, row);
        } else { //双击事件
          _this.selectsingle(val, row);
        }
        _this.nowtime = 0;
        _this.timeoutflag = true;
      }, 250);
    },

    /** 单击商品 **/
    selectrow(val, row) {
      var _this = this;
      var id = val.id;
      var status = -1;
      this.selectproductids.indexOf(id) >= 0 ? this.selectproductids.splice(this.selectproductids.indexOf(id), 1) : this.selectproductids.push(id);
      this.productlists.forEach(function (e, index) { e.id == id ? status = index : '' });
      if (status >= 0) this.$refs.multipleTable.toggleRowSelection(this.productlists[status]);
    },

    /** 双击选择商品 **/
    selectsingle(val, row) {
      this.selectproductids = [];
      //添加商品进入购物车
    },

    /** 单选商品信息 **/
    handleSelectsingle(val, row) {
      var _this = this;
      var id = row.id;
      this.selectproductids.indexOf(id) >= 0 ? this.selectproductids.splice(this.selectproductids.indexOf(id), 1) : this.selectproductids.push(id);
    },

    /** 全选/全不选添加商品信息 **/
    handleSelectionChange(val, row) {
      var _this = this;
      var pstatus = 0;
      var status = 0;
      var nowproductids = [];
      if (this.selectproductids.length == 0) {
        val.forEach(function (e, index) { _this.selectproductids.push(e.id) });
        return false;
      }

      //获取当前列表信息状态
      this.productlists.forEach(function (e, index) { nowproductids.push({ id: e.id, status: false }) });
      nowproductids.forEach(function (e, i) {
        pstatus = 0;
        val.forEach(function (ee, ii) {
          if (e.id == ee.id) pstatus = 1;
        });
        pstatus == 1 ? nowproductids[i].status = true : '';
      });

      nowproductids.forEach(function (e, i) {
        if (e.status == true && _this.selectproductids.indexOf(e.id) < 0) _this.selectproductids.push(e.id);
        if (e.status == false && _this.selectproductids.indexOf(e.id) >= 0) _this.selectproductids.splice(_this.selectproductids.indexOf(e.id), 1);
      });
    },

    /** 默认勾选已选择的商品信息 **/
    defaultselectgoods() {
      var _this = this;
      setTimeout(function () {
        _this.productlists.forEach(function (e, i) {
          if (_this.selectproductids.indexOf(e.id) >= 0) _this.$refs.multipleTable.toggleRowSelection(e);
        })
      }, 100);
    },

    /** 添加商品进入购物车 **/
    addgoods() {
      if (this.selectproductids.length == 0) { this.$message.error('请添加需要采购的商品'); return false; }
      var resource = this.$resource(this.url);
      resource.save({ act: 'addinventory', token: this.$cookies.get('token'), type: this.create.type, goodsids: this.selectproductids }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.$message.success('添加商品信息成功');
          this.addgoodsDialog = false;
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 复制订单商品信息 **/
    copygoods(id) {
      this.$confirm('您是否需要对该商品信息进行复制？', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'copygoods', id: id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('商品信息复制成功！');
            this.getsingleorder(this.create.type);
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },

    /** 删除订单商品信息 **/
    delgoods(id) {
      this.$confirm('您是否需要删除该商品信息？', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delgoods', id: id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('删除商品信息成功！');
            this.getsingleorder(this.create.type);
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },

    /** 获取单位信息 **/
    getUnitlists(productid, id, unitid) {
      this.changegoodsid = id;
      this.changeunitid = unitid;
      // 向请求服务端删除
      this.unitDialog = true;
      this.unitListLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'getunitlists', id: productid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
        this.unitListLoading = false;
      });
    },

    /** 保存商品单位信息 **/
    saveunitid(unitid) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'saveunitid', id: this.changegoodsid, unitid: unitid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.unitDialog = false;
          this.$message.success('修改商品单位信息成功！');
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 修改商品金额 **/
    setgoodssell(id, sell) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setsell', id: id, sell: sell, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 修改数量信息 **/
    setgoodsnum(id, num) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setnums', id: id, num: num, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 小改商品小计 **/
    setgoodstotal(id, total) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'settotal', id: id, total: total, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 设置优惠金额 **/
    setderate() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setderate', type: this.create.type, derate: this.create.derate, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 设置应付金额 **/
    setdeal() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setdeal', type: this.create.type, deal: this.create.deals, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 设置备注信息 **/
    setdesc() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setdesc', type: this.create.type, desc: this.create.desc, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 修改供应商 **/
    changesupplier() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setsupplier', type: this.create.type, supplierid: this.create.supplierid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 修改采购人信息 **/
    setseller() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'setseller', type: this.create.type, clerkid: this.create.clerkid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getsingleorder(this.create.type);
        } else {
          this.getsingleorder(this.create.type);
        }
      }).catch((res) => {

      });
    },

    /** 清空已选中的采购商品 **/
    clearselectgoods() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }
      this.$confirm('您是否确定删除采购商品里所有商品的信息？', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'cleargoods', type: this.create.type, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('删除采购商品信息成功！');
            this.getsingleorder(this.create.type);
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },


    //商品拖拽排序
    getdata(evt) {
      console.log(evt.draggedContext.element.id);
    },
    datadragEnd(evt) {
      console.log('拖动前的索引：' + evt.oldIndex);
      console.log('拖动后的索引：' + evt.newIndex);
    },

    /** 启用/停止排序 **/
    startandstopsort() {
      if (this.sorttable == true) {
        this.sorttable = false;
        this.sorttype = 'danger';
        this.sorticon = 'el-icon-circle-close-outline';
        this.sortname = '停止排序';
      } else {
        this.sorttable = true;
        this.sorttype = 'success';
        this.sorticon = 'el-icon-circle-check-outline';
        this.sortname = '启用排序';
        var result = [];
        var count = this.listsorts.length;
        this.listsorts.forEach(function (e, index) {
          count--;
          result.push({ id: e.id, sort: count });
        });

        var resource = this.$resource(this.url);
        resource.save({ act: 'changesort', token: this.$cookies.get('token'), sortlists: result }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('删除采购商品信息成功！');
            this.getsingleorder(this.create.type);
          }
        }).catch((res) => {

        });

      }
    },

    /** 保存订单信息 **/
    saveorder() {
      this.saveorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveorderLoading = false;
        } else {
          this.$message.success('删除采购商品信息成功！');
          this.saveorderLoading = false;
          this.addDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        this.saveorderLoading = false;
      });
    },

    /** 获取订单信息 **/
    geteditorder(id) {
      this.$emit('listenchild', { name: '编辑采购单', url: 'Purcharorderedit', data: id });
      /**
      this.create.id=id;
      var resource = this.$resource(this.url);
      resource.save({act:'geteditorder',token:this.$cookies.get('token'),id:id}).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
              this.addDialog=true;
          this.selectproductids=[];			    	
          this.sorttable=true;
          this.sorttype='success';
          this.sorticon='el-icon-circle-check-outline';
          this.sortname='启用排序';	    	
                this.getsingleorder(2);
            }
        }).catch((res) => {
        	
        });
        */
    },

    /** 删除单个订单信息 **/
    delorder() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }
      this.$confirm('您是否确定删除该订单信息？', '提示', { type: 'warning' }).then(() => {
        var id = this.create.id;
        this.delorderLoading = true;
        var resource = this.$resource(this.url);
        resource.save({ act: 'delorder', token: this.$cookies.get('token'), id: id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.delorderLoading = false;
          } else {
            this.$message.success("删除订单信息成功！");
            this.delorderLoading = false;
            this.addDialog = false;
            this.getOrderlists();
          }
        }).catch((res) => {
          this.delorderLoading = false;
        });
      }).catch(() => {

      });
    },

    /** 审核订单信息 **/
    verifyorder() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }
      var id = this.create.id;
      this.verifyorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'verifyorder', token: this.$cookies.get('token'), id: id, type: this.create.type, clerkid: this.create.clerkid }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.verifyorderLoading = false;
        } else {
          this.$message.success("删除订单信息成功！");
          this.verifyorderLoading = false;
          this.addDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        this.delorderLoading = false;
      });
    },

    /** 审核并打印订单信息 **/
    verifyandprintorder() {
      if (this.sorttable == false) { this.$message.error('请选停止排序'); return false; }
      var id = this.create.id;
      this.verifyandprintLoading = true;
      this.verifyorder(); //审核信息
      this.verifyandprintLoading = false;
      this.getprintorder(id); //获取订单打印信息
    },

    //获取打印订单信息
    getprintorder(id) {
      this.printLoading = true;
      this.printerDialog = true;
      this.printlists = [];
      var resource = this.$resource(this.url);
      resource.save({ act: 'getprintinfos', token: this.$cookies.get('token'), id: id, rollpage: this.rollpage }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printLoading = false;
          this.printlists = JSON.parse(Base64.decode(res.data.Data));
          this.orderstatus = this.printlists[0].status;
        }
      }).catch((res) => {
        this.printLoading = false;
      });
    },

    //修改订单打印每页展示条数
    changepagevlaue(id) {
      this.getprintorder(id);
    },

    //打印订单
    createnoSave() {
      var id = this.printlists[0].id;
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeprintnumber', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          this.printorderLoading = false;
          this.printlocalpage(); //打印 
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },

    /** 打印当前页面 **/
    printlocalpage() {
      //设置打印完成后回调页面
      this.$cookies.set('returnurlids', 'Purcharorder');
      //保留搜索前的数据
      var data = {};
      data.querychange = this.querychange;
      data.query = this.query;
      this.$cookies.set('print_back_data_Purcharorder', JSON.stringify(data));


      //设置打印信息
      var div_print = document.getElementById('printContent');
      var newStr = div_print.innerHTML;
      var oldStr = document.body.innerHTML;
      document.body.innerHTML = newStr;
      window.print();
      document.body.innerHTML = oldStr;
      location.reload();
    },

    /** 撤销订单信息 **/
    cannelverify() {
      this.$confirm('您是否确定撤销采购单信息审核？', '提示', { type: 'warning' }).then(() => {
        var id = this.printlists[0].id;
        this.printerDialog = false;
        this.cannelLoading = true;
        var resource = this.$resource(this.url);
        resource.save({ act: 'cannelorder', token: this.$cookies.get('token'), id: id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.cannelLoading = false;
          } else {
            this.cannelLoading = false;
            this.getOrderlists();
            this.$message.success("撤销订单审核成功");
          }
        }).catch((res) => {
          this.cannelLoading = false;
        });
      }).catch(() => {

      });
    },


    /** 完成订单 **/
    finishorder() {
      var id = this.printlists[0].id;
      this.finishLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'finishorder', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.finishLoading = false;
        } else {
          this.$message.success("采购单生效成功！");
          this.finishLoading = false;
          this.printerDialog = false;
          this.getOrderlists();
          //获取订单进货入库商品信息
          // if(this.actionauth.cg_order_create=='true') this.getinputgoods(id);
          if (res.data.Data) {
            const getCurrData = JSON.parse(Base64.decode(res.data.Data));
            this.inStore({ storage_order_id: getCurrData.id })
          }
        }
      }).catch((res) => {
        this.finishLoading = false;
      });
    },

    //获取进货入库商品信息列表
    getinputgoods(id) {
      this.inputDialog = true;
      this.inputLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'getinputgoods', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.inputLoading = false;
        } else {
          this.inputid = id;
          this.inputlists = JSON.parse(Base64.decode(res.data.Data));
          this.inputLoading = false;
        }
      }).catch((res) => {
        this.inputLoading = false;
      });
    },

    //新增赠送采购入库商品信息
    addgift() {
      this.giftselectproductids = [];
      this.giftquery.ids = [];
      this.giftquery.applyid = '';
      this.giftquery.brandid = '';
      this.giftquery.catid = '';
      this.giftquery.key = '';

      var _this = this;
      var applyid = 0;
      var giftids = [];
      //取出供应商信息
      this.orderlists.forEach(function (e, index) { if (e.id == _this.inputid) applyid = e.applyid });
      this.giftquery.applyid = applyid;
      //当前已添加的赠品信息
      this.inputlists.forEach(function (e, index) { if (e.isgift == 1) giftids.push(e.id) });
      this.giftquery.ids = giftids;
      this.getgiftgoods();
    },

    //获取赠送商品列表信息
    getgiftgoods() {
      this.giftDialog = true;
      this.giftLoading = true;
      this.addgiftListLoading = true;
      if (this.selectgiftproduct == true) {
        this.giftquery.p = 1;
        this.giftquery.rollpage = 10;
      }

      var resource = this.$resource(this.url);
      resource.save(this.giftquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.giftLoading = false;
        } else {
          this.giftlists = JSON.parse(Base64.decode(res.data.Data));
          this.product_gift_row = parseInt(res.data.count);
          this.giftLoading = false;
          this.addgiftListLoading = false;
          if (this.selectgiftproduct == true) this.selectgiftproduct = false;
          this.defaultselectgiftgoods(); //获取已勾选的商品信息
        }
      }).catch((res) => {
        this.giftLoading = false;
      });
    },

    giftproductPageSizeChange(val) {
      this.giftquery.rollpage = val;
      this.getgiftgoods();
    },
    giftproductPageCurrentChange(val) {
      this.giftquery.p = val;
      this.getgiftgoods();
    },

    /** 改变品牌 **/
    changegiftbrand() {
      this.selectgiftproduct == true;
      this.getgiftgoods();
    },

    /** 改变分类 **/
    changegiftcate() {
      this.selectgiftproduct == true;
      this.getgiftgoods();
    },

    /** 关键字搜索 **/
    changegiftsearchkey() {
      //网络异常请求加载数据缓慢时禁止向服务器请求加载数据，缓解服务器压力，等上一次数据加载完后再重亲请求加载数据
      if (this.addgiftListLoading == true) { return false; }
      this.getgiftgoods();
    },

    /** 点击单行选择/取消选中商品  **/
    giftrowclick(val, row) {
      this.giftnowtime++;
      if (this.gifttimeoutflag == false) return false;

      var _this = this;
      this.gifttimeoutflag = false;
      setTimeout(function () {
        if (_this.giftnowtime == 1) { //单击事件
          _this.selecgifttrow(val, row);
        } else { //双击事件
          _this.selectgiftsingle(val, row);
        }
        _this.giftnowtime = 0;
        _this.gifttimeoutflag = true;
      }, 250);
    },

    /** 单击商品 **/
    selecgifttrow(val, row) {
      var _this = this;
      var id = val.id;
      var status = -1;
      this.giftselectproductids.indexOf(id) >= 0 ? this.giftselectproductids.splice(this.giftselectproductids.indexOf(id), 1) : this.giftselectproductids.push(id);
      this.giftlists.forEach(function (e, index) { e.id == id ? status = index : '' });
      if (status >= 0) this.$refs.giftmultipleTable.toggleRowSelection(this.giftlists[status]);
    },

    /** 双击选择商品 **/
    selectgiftsingle(val, row) {
      this.giftselectproductids = [];
      this.giftselectproductids.push(val.id);
      //添加商品进入购物车
      this.addgiftgoods();
    },

    /** 单选商品信息 **/
    gifthandleSelectsingle(val, row) {
      var _this = this;
      var id = row.id;
      this.giftselectproductids.indexOf(id) >= 0 ? this.giftselectproductids.splice(this.giftselectproductids.indexOf(id), 1) : this.giftselectproductids.push(id);
    },

    /** 全选/全不选添加商品信息 **/
    gifthandleSelectionChange(val, row) {
      var _this = this;
      var pstatus = 0;
      var status = 0;
      var nowproductids = [];

      if (this.giftselectproductids.length == 0) {
        val.forEach(function (e, index) { _this.giftselectproductids.push(e.id) });
        return false;
      }

      //获取当前列表信息状态
      this.giftlists.forEach(function (e, index) { nowproductids.push({ id: e.id, status: false }) });
      nowproductids.forEach(function (e, i) {
        pstatus = 0;
        val.forEach(function (ee, ii) {
          if (e.id == ee.id) pstatus = 1;
        });
        pstatus == 1 ? nowproductids[i].status = true : '';
      });

      nowproductids.forEach(function (e, i) {
        if (e.status == true && _this.giftselectproductids.indexOf(e.id) < 0) _this.giftselectproductids.push(e.id);
        if (e.status == false && _this.giftselectproductids.indexOf(e.id) >= 0) _this.giftselectproductids.splice(_this.giftselectproductids.indexOf(e.id), 1);
      });
    },

    /** 默认勾选已选择的商品信息 **/
    defaultselectgiftgoods() {
      var _this = this;
      setTimeout(function () {
        _this.giftlists.forEach(function (e, i) {
          if (_this.giftselectproductids.indexOf(e.id) >= 0) _this.$refs.giftmultipleTable.toggleRowSelection(e);
        })
      }, 100);
    },

    //确认添加赠送商品
    addgiftgoods() {
      if (this.giftselectproductids.length == 0) { this.$message.error("请选择要赠送的商品信息"); return false; }
      var resource = this.$resource(this.url);
      resource.save({ act: 'checkgiftgoods', token: this.$cookies.get('token'), ids: this.giftselectproductids }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          var _this = this;
          result.forEach(function (e, index) { _this.inputlists.push(e) });
          this.giftDialog = false;
        }
      }).catch((res) => {

      });
    },

    //删除已添加的赠品
    delgift(index) {
      this.inputlists.splice(index, 1);
    },


    //修改采购商品进货入库数量
    changenum(index, item) {
      var total = item.sell * item.paynum;
      this.inputlists[index].paytotal = total.toFixed(2);
    },

    //生成进货入库单信息
    savestorage() {
      var data = [];
      this.inputlists.forEach(function (item, i) {
        if (item.paynum > 0) data.push(item);
      });

      this.$confirm('您是否确定要生成进货入库单？', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.save({ act: 'createstorage', token: this.$cookies.get('token'), data: this.inputlists }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('生成进货入库单成功，请前往进货入库对生成的单子进行商品入库操作！');
            this.getOrderlists();
            this.inputDialog = false;
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },

    //获取采购单已入库商品历史记录
    getstoragelog(id) {
      this.purchasecreateDialog = true;
      this.purchasecreateLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'getcreatestoragelog', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.purchasecreatelog = JSON.parse(Base64.decode(res.data.Data));
          this.purchasecreateLoading = false;
        }
      }).catch((res) => {

      });
    },

    /** 导出进货入库单 **/
    exportorder() {
      this.getOrderlists();
      this.printerDialog = false;
      this.exportquery.id = this.printlists[0].id;
      this.exportquery.date = [];
      this.exportquery.clerkid = [];
      this.exportquery.supplierid = '';
      this.exportquery.status = '';
      this.exportquery.key = '';
      this.getexportdata();
    },

    /** 导出更多采购单信息 **/
    exportmoredata() {
      this.exportquery.id = 0;
      this.exportquery.date = this.query.date;
      this.exportquery.clerkid = this.query.clerkid;
      this.exportquery.supplierid = this.query.supplierid;
      this.exportquery.status = this.query.status;
      this.exportquery.key = this.query.key;
      this.getexportdata();
    },

    /** 获取进货入库商品信息 **/
    getexportdata() {
      this.exportorderDialog = true;
      this.exportorderLoading = true;
      var resource = this.$resource(this.GLOBAL.exportUrl + "Purchase/index");
      resource.save(this.exportquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.exportorderLoading = false;
        } else {
          this.exportdata = JSON.parse(Base64.decode(res.data.Data));
          this.exportorderLoading = false;
        }
      }).catch((res) => {
        this.exportorderLoading = false;
      });
    },

    /** 确认导出订单信息 **/
    sureoutput() {
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['序号', '单据编号', '编号', '商品', '箱装规格', '规格', '单位', '数量', '剩余入库数量', '单价', '折扣', '折后单价', '小计', '下单时间', '审核时间', '供应商', '采购人', '审核人'];
        var filterVal = ['gsort', 'documents', 'number', 'name', 'box_gauge', 'spec', 'unit', 'num', 'remaining_quantity', 'price', 'discount', 'sell', 'total', 'inputtime', 'verifytime', 'suppliername', 'clerkname', 'verifyername'];

        var list = this.exportdata;
        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '采购单记录');
        this.exportorderDialog = false;
      })
    },

    //导出表格数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    /** 修改采购入库单 **/
    changepurcharseorder(id) {
      this.editorderDialog = true;
      this.editorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'geteditorderinfos', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.editorderLoading = false;
        } else {
          this.editlistsdata = JSON.parse(Base64.decode(res.data.Data));
          this.editorderLoading = false;
        }
      }).catch((res) => {
        this.editorderLoading = false;
      });
    },

    /** 保存修改后的采购单 **/
    saveeditorder() {
      this.$confirm('温馨提示：您是否确定要对该采购单信息进行修改？', '提示', { type: 'warning' }).then(() => {
        this.saveeditloading = true;
        var resource = this.$resource(this.url);
        resource.save({ act: 'saveeditorder', token: this.$cookies.get('token'), data: this.editlistsdata }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.saveeditloading = false;
          } else {
            this.editorderDialog = false;
            this.saveeditloading = false;
            this.getOrderlists();
          }
        }).catch((res) => {
          this.saveeditloading = false;
        });

      }).catch(() => {

      });
    },


    /** 获取改单记录 **/
    changepurcharseeditlog(id) {
      this.editlogDialog = true;
      this.editlogloading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'geteditlogs', token: this.$cookies.get('token'), orderid: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.editlogloading = false;
        } else {
          this.editlogloading = false;
          this.editlogs = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.editlogloading = false;
      });
    },

    /** 将订单数据提交至金蝶 **/
    kingdeesellsubmit(item) {
      this.$confirm('警告：操作前请确认该订单是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.query({ act: 'kingdeesubmit', orderid: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getOrderlists();
            this.$message.success('订单数据提交到金蝶成功');
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },


    /** 获取当前复制的订单信息 **/
    copyorders(id) {
      this.$confirm('该操作会清空原已添加挂起的采购商品并将当前复制的采购单商品信息进行填充，你是否确定', '提示', { type: 'warning' }).then(() => {

        var loading = this.$loading({
          lock: true,
          text: '数据正在复制中，请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)'
        });

        var resource = this.$resource(this.url);
        resource.query({ act: 'copyorderstoadd', id: id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            loading.close();
          } else {
            //跳转到开单界面
            this.$emit('listenchild', { name: '新增采购单', url: 'Purcharorderadd', data: { isreshpurchaseadd: 2 } });
            loading.close();
          }
        }).catch((res) => {
          loading.close();
        });

      }).catch(() => {

      });
    },
    inStore(item) {
      this.$emit('listenchild', { name: '编辑进货入库单', url: 'Storageedit', data: { id: item.storage_order_id || "" } });
    },
    // 入库检测
    checkInStoreList(row) {
      // ???????????????
      if (this.batchStatus) {
        // 开启货位的入库方式
        this.$refs.checkInStoreDialogRef.openDialog(row)
      } else {
        // 不开启货位的入库方式

        this.checkInStoreOld(row)
      }
    },
    checkInStoreOld(row) {
      // if(row.storage_order_id>0){
      // 	this.inStore(row)
      // }else{
      var resource = this.$resource(this.GLOBAL.domain + "Purchase/index");
      resource.query({ act: 'create_storage_v2', id: row.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          const resp = JSON.parse(Base64.decode(res.data.Data));
          this.inStore({ storage_order_id: resp.id })
        }
      }).catch((res) => {

      });
      // }
    },
    handleCheckInStore({ row, type }) {
      this.checkInStore(row, type)
    },
    checkInStore(row, type) {
      console.log(type, 'TYE')
      
      var resource = this.$resource(this.GLOBAL.domain + "Purchase/index");
      resource.query({ act: 'create_storage_v2', type, id: row.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          const resp = JSON.parse(Base64.decode(res.data.Data));
          if (type == 1) {
            this.inStore({ storage_order_id: resp.id })
          } else {
            this.$message.success('PDA入库操作成功！');
          }
        }
      })
      .finally(() => {
        this.getOrderlists();
      })

    }
  }
}
</script>
<style type="text/css">
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

.titlelists {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0
}

.titlelists li {
  float: left;
  width: 33.3%;
  font-size: 15px;
  list-style-type: none
}

.top1 td {
  padding-top: 2px;
  font-size: 15px
}

.top2 td {
  padding-top: 2px;
  font-size: 15px;
}

.top1 td span {
  font-size: 15px
}

.top2 td span {
  font-size: 15px
}

.sureprint {
  float: right;
  margin-right: 15.5%
}

.editlogs {
  margin: 0;
  padding: .5rem
}

.editlogs li {
  float: left;
  width: 100%;
  margin-bottom: 50px;
  list-style-type: none;
}

.editlogs li .title {
  float: left;
  width: 100%;
  padding: .5rem 0
}

.editlogs li .title span {
  float: left;
  font-size: .9rem;
  color: #666666;
  margin-right: 5%;
  line-height: 1.2rem
}

.editlogs li .title h {
  float: left;
  width: 100%;
  font-size: .9rem;
  color: #666666;
  line-height: 1.5rem;
  margin-top: .5rem
}

.editlogs li .goodslists {
  float: left;
  width: 96%;
  padding: .5rem 2%;
  border: 1px soild rgb(221, 221, 221, .5);
  background: rgb(221, 221, 221, .3);
  border-radius: 5px
}

.editlogs li .goodslists .goods {
  float: left;
  width: 100%;
  padding: .5rem 0;
  font-size: .9rem;
  color: #666666;
}

.editlogs li .goodslists .goods .name,
.editlogs li .goodslists .goods .number,
.editlogs li .goodslists .goods .spec,
.editlogs li .goodslists .goods .num,
.editlogs li .goodslists .goods .basenum,
.editlogs li .goodslists .goods .unit {
  float: left;
  margin-right: 2%
}

.editlogs li .goodslists .goods .name {
  width: 60%
}

.editlogs li .goodslists .goods .spec {
  width: 10%;
  margin-left: 5%
}

.editlogs li .goodslists .goods .number {
  width: 10%;
  margin-left: 5%
}

.editlogs li .goodslists .goods .num {
  margin-right: 1%
}

.editlogs li .goodslists .goods .basenum {
  margin-right: 1%;
  text-decoration: line-through;
  color: red
}

.editlogs li .goodslists .goods .unit {
  margin-right: 0
}


@media print {
  .pageBreak {
    page-break-after: always;
  }

  .noPrint {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/purchase/order.vue